__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "riskshield";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@cashfree-intl/coherent", "5.0.0-development.147", () => (() => (__webpack_require__(9011))), 1);
			register("apexcharts", "3.49.2", () => (__webpack_require__.e("npm.apexcharts").then(() => (() => (__webpack_require__(35927))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e("npm.react-dom"), __webpack_require__.e("npm.scheduler")]).then(() => (() => (__webpack_require__(73935))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e("npm.babel"), __webpack_require__.e("npm.hoist-non-react-statics"), __webpack_require__.e("npm.react-redux")]).then(() => (() => (__webpack_require__(28216))))));
			register("react-router-dom", "6.15.0", () => (Promise.all([__webpack_require__.e("npm.remix-run"), __webpack_require__.e("npm.react-router"), __webpack_require__.e("npm.react-router-dom")]).then(() => (() => (__webpack_require__(79655))))));
			register("react", "18.2.0", () => (__webpack_require__.e("npm.react").then(() => (() => (__webpack_require__(67294))))));
			register("redux-injectors", "2.1.0", () => (Promise.all([__webpack_require__.e("npm.lodash"), __webpack_require__.e("npm.invariant"), __webpack_require__.e("npm.hoist-non-react-statics"), __webpack_require__.e("npm.redux-injectors"), __webpack_require__.e("webpack_sharing_consume_default_react-redux_react-redux")]).then(() => (() => (__webpack_require__(13295))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e("npm.hoist-non-react-statics"), __webpack_require__.e("npm.shallowequal"), __webpack_require__.e("npm.emotion"), __webpack_require__.e("npm.react-is"), __webpack_require__.e("npm.styled-components")]).then(() => (() => (__webpack_require__(71893))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};